<p>operation-note-participant-item works!</p>
